import _ from "lodash";

export const hasViewAccess = (path, routes) => {
  if (path.length === 0) return true;
  const findRoute = (routes, path) => {
    return _.some(routes, (route) => {
      if (
        path?.includes(route.path) &&
        route.access &&
        _.get(route, "permission.view", false)
      ) {
        return true;
      }
      if (route.subMenu && route.subMenu.length > 0) {
        return findRoute(route.subMenu, path);
      }
      return false;
    });
  };

  return findRoute(routes, path);
};

// Permission object for a menu key (searches sub menus too) in the current
// role's menu list, or null when the menu is missing or has no access.
export const getMenuPermission = (menuList, userRoleId, key) => {
  const roleMenus = menuList?.[userRoleId] || Object.values(menuList || {})[0];
  const findMenu = (menus) => {
    for (const menu of menus || []) {
      if (menu?.key === key) return menu;
      const found = findMenu(menu?.subMenu);
      if (found) return found;
    }
    return null;
  };
  const menu = findMenu(roleMenus);
  return menu?.access ? menu.permission || null : null;
};
